const initialState = {
    data: false,
}
export const SplashScreenReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SPLASHVAL':
            return {
                ...state,
                data: action.payload,
            };
        default:
            return state;
    }
}

export default SplashScreenReducer;